// src/components/Cursor.tsx
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const CursorFollower = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [hasMoved, setHasMoved] = useState(false); // Track if the mouse has moved
  const [isMoving, setIsMoving] = useState(true); // Track if the mouse is moving

  const cursorSize = 20; // Adjust the size of the cursor

  useEffect(() => {
    const moveCursor = (e: MouseEvent) => {
      if (!hasMoved) {
        setHasMoved(true); // Set to true when mouse first moves
      }
      setPosition({ x: e.clientX, y: e.clientY });
      setIsMoving(true); // Mouse is moving
    };

    const stopCursor = () => {
      setIsMoving(false); // Mouse has stopped
    };

    window.addEventListener("mousemove", moveCursor);
    window.addEventListener("mouseout", stopCursor); // Mouse leaves the window
    return () => {
      window.removeEventListener("mousemove", moveCursor);
      window.removeEventListener("mouseout", stopCursor);
    };
  }, [hasMoved]);

  // Apply an offset when the mouse is moving
  const offset = isMoving ? -cursorSize / 4 : 0; // Offset the cursor when moving

  return (
    <>
      {hasMoved && (  // Only render the cursor after it has moved
        <motion.div
          className="fixed top-0 left-0 pointer-events-none"
          style={{
            x: position.x + offset,
            y: position.y + offset,
            width: cursorSize/2,
            height: cursorSize/2,
            backgroundColor: "rgb(255, 0, 0)",  // Brighter red color
            borderRadius: "50%",
            zIndex: 9999,
          }}
          animate={{ x: position.x + offset, y: position.y + offset }}
          transition={{ type: "tween", ease: "easeOut", duration: 0.1 }}
        />
      )}
    </>
  );
};

export default CursorFollower;
